import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { AudienceFields, type AudienceForm } from '../../../types.ts';
import { hasInternationalCriteriaInDefinition } from '../../../utils/hasInternationalCriteria.ts';
import {
  getAnyIncludesMarketRestrictionReason,
  getShouldUseRegionFirstFlow,
} from '../../../utils/marketOperatorRestrictions.ts';

export const useIncludesMarketBlockExcludes = ({
  isCreate,
  isCreateFromTemplate,
}: {
  isCreate?: boolean;
  isCreateFromTemplate?: boolean;
}) => {
  const normalizedDefinition = useWatch<AudienceForm, typeof AudienceFields.NormalizedDefinition>({
    name: AudienceFields.NormalizedDefinition,
  });

  const accountId = useWatch<AudienceForm, typeof AudienceFields.OrganizationId>({
    name: AudienceFields.OrganizationId,
  });

  const includesGroups = normalizedDefinition?.includes?.groups;

  const shouldUseRegionFirstFlow = useMemo(
    () =>
      getShouldUseRegionFirstFlow({
        isCreate,
        isCreateFromTemplate,
        hasInternationalCriteria: hasInternationalCriteriaInDefinition(normalizedDefinition),
      }),
    [isCreate, isCreateFromTemplate, normalizedDefinition]
  );

  const blockReason = useMemo(
    () => getAnyIncludesMarketRestrictionReason(includesGroups, accountId ?? '', shouldUseRegionFirstFlow, true),
    [includesGroups, accountId, shouldUseRegionFirstFlow]
  );

  return { blockReason };
};
